import styled from 'styled-components';
import { centerFlex, getColor, wh } from '../../styles/mixins';
import { Box, Flex } from '..';
import { store } from '../../redux/store';
import { GearIcon } from '@modulz/radix-icons';
import { ReactComponent as AlertIconComponent } from '../../assets/icons/alert-yellow.svg';

export const Root = styled(Flex)`
  background-color: ${getColor('gray', 900)};
  height: 48px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  z-index: 5;
`;

export const NavbarLogo = styled(Box)`
  display: flex;
  height: 100%;
  align-items: center;
  padding: 0 16px;
  cursor: pointer;
`;

export const UserDetails = styled(Box)`
  padding: 0 16px;
`;

export const ProfileContainer = styled(Flex)`
  width: fit-content;
  align-items: center;
  height: 48px;
`;

export const ProfileText = styled(Flex)`
  font-size: 20px;
  align-items: center;
`;

export const SettingsIcon = styled(Box).attrs({ as: GearIcon })`
  width: 20px;
  height: 20px;
  cursor: pointer;
  padding-top: 7px;
  color: ${getColor('gray', 0)};
`;

export const AvatarContainer = styled(Flex)`
  ${wh(24)};
  ${centerFlex};
  background-color: white;
  align-items: center;
  margin-right: 12px;
  border: 1px solid #151515;
  border-radius: 20px;
  overflow: hidden;
`;

export const Avatar = styled(Box)`
  ${wh(24)};
  background: ${`url('https://avatars.dicebear.com/api/initials/${store
    .getState()
    .userR.user?.username.slice(0, 1)}.svg')`};
`;

export const AlertIcon = styled(Box).attrs({ as: AlertIconComponent })`
  width: 20px;
  height: 20px;
  margin-right: 12px;
`;
